<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
  <div class="tw:w-full tw:px-[15px]">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:flex-1 tw:px-[15px] back-arrow-icon-container"
        data-toggle="tooltip" data-placement="top" title="Back to learner list">
        <div class="back-arrow-icon cursor-pointer" (click)="backToStudentList()"></div>
      </div>
      <div class="tw:flex-1 tw:px-0 tw:flex">
        <h5 class="panel-title student-header-text-primary">{{student.studentFirstName}}
          {{student.studentLastName}}
          <span class="student-attendance">{{!student.attendanceInformation ? "" : "- " +
          student.attendanceInformation}}</span>
        </h5>
      </div>
    </div>
  </div>
  <div class="tw:w-full tw:px-[15px]">
    <mat-accordion>
      <mat-expansion-panel class="mat-expansion-panel-spacing"
        (opened)="ilpPanelOpenState = true"
        (closed)="ilpPanelOpenState = false">
        <mat-expansion-panel-header #baselineHeader (click)="renderStudentBaseline()">
          @if (!ilpPanelOpenState) {
            <mat-panel-title>
              <h5 class="panel-title">{{themeService.siteContent.tutorReportsBaselineHeader}}</h5>
            </mat-panel-title>
          }
        </mat-expansion-panel-header>
        <tutorreports-baseline
          #refBaseline
          (onClosed)="onBaselineClosed(baselineHeader)"
          (statusUpdated)="baselineStatusUpdated($event)"
          [groupStudentId]="student.studentId"
          [studentIdForLinkAssessment]="student.studentId"
          >
        </tutorreports-baseline>
      </mat-expansion-panel>

      <mat-expansion-panel class="mat-expansion-panel-spacing">
        <mat-expansion-panel-header (click)="renderStudentProgressReport(refOutcomes)">
          <mat-panel-title>
            <h5 class="panel-title">{{themeService.siteContent.tutorReportsProgressReportHeader}}</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <student-outcomes #refOutcomes
          [groupStudentId]="student.studentId"
        [groupStudentFullName]="student.studentFirstName + ' ' + student.studentLastName" >loading</student-outcomes>
      </mat-expansion-panel>

      @if (generateStudentAccessPermission) {
        <mat-expansion-panel class="mat-expansion-panel-spacing">
          <mat-expansion-panel-header (click)="grantStudentAccess()">
            <mat-panel-title>
              <h5 class="panel-title">Grant Learner Access</h5>
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      }

    </mat-accordion>
  </div>
</div>